import React, { useRef, useCallback } from "react";
import { Button } from "devextreme-react/button";
import ContextMenu from "devextreme-react/context-menu";
import { alert } from "devextreme/ui/dialog";
import { MESSAGES } from "../../../common/Messages";
import AdjustAvailableUnAvailableReportMenuItems from "./reportMenuItems";
import "./adjustAvailableUnavailable.css";

/**
 * Print menu for the Adjust Available Unavailable Status screen (Delphi WMD0051).
 *
 * Deliberately NOT the OM `PrintReportMenu`: that one builds its items from the DB report groups and
 * gates them on OMReports permissions, so it would list the OM reports, not these three. The WMD0051
 * reports (WMR0055 / WMR0071 / WMR0072) are not migrated yet, so the menu is a static list here and
 * every entry reports "under construction". The button + ContextMenu mechanics mirror PrintReportMenu
 * so both Print buttons behave the same way.
 *
 * See reportMenuItems.js for how Delphi assembles the list, and why the entries carry a '* ' prefix.
 */
const AdjustAvailableUnAvailableReportMenu = () => {
    const buttonId = "adjustAvailableUnavailablePrintButton";
    const contextMenuRef = useRef(null);

    const showMenu = useCallback(() => {
        if (contextMenuRef.current) {
            contextMenuRef.current.instance().show();
        }
    }, []);

    const onItemClick = useCallback(() => {
        alert(MESSAGES.FUNCTIONALITY_UNDER_CONSTRUCTION, MESSAGES.INFORMATION);
    }, []);

    return (
        <React.Fragment>
            {/* Plain text button — deliberately NO `render` template. A templated DevExtreme Button
                nests its own TemplateManager inside this toolbar item's template, and when the item is
                rebuilt on a host re-render that manager sets state after unmount ("state update on an
                unmounted component"). The trailing chevron therefore comes from a CSS ::after on
                .wm-dropdown-button, not from custom content. The `icon` prop is not an option either:
                DevExtreme 25.1 has no iconPosition, so it would sit before the text. */}
            <Button
                id={buttonId}
                className="gridTopButton wm-dropdown-button"
                type="default"
                text="Print"
                hint="Print Report(s)"
                onClick={showMenu}
            />
            {/* Delphi anchors the popup to the bottom-left corner of the Print button. */}
            <ContextMenu
                ref={contextMenuRef}
                dataSource={AdjustAvailableUnAvailableReportMenuItems}
                target={`#${buttonId}`}
                showEvent=""
                position={{ my: "top left", at: "bottom left", of: `#${buttonId}` }}
                onItemClick={onItemClick}
            />
        </React.Fragment>
    );
};

export default AdjustAvailableUnAvailableReportMenu;
